const countryData = [
  {
    countryName: 'Saudi Arabia',
    countryNameAr: 'السعودية',
    shortCountryName: 'Saudi',
    countryCode: 'SA',
    longCountryCode: 'KSA',
    currency: 'SAR',
    currencyAr: 'ر.س',
    telephoneCode: '966',
    decimalDigits: 2,
    timezone: 'Asia/Riyadh',
    gmt: '+3',
    currencyName: 'Riyal',
    numberStartsWith: [5],
    numberMinLength: 9,
    numberMaxLength: 10,
    vat: 15,
    location: {
      lat: 24.774265,
      lng: 46.738586,
    },
  },
  {
    countryName: 'United Arab Emirates',
    countryNameAr: 'الإمارات',
    shortCountryName: 'UAE',
    countryCode: 'AE',
    longCountryCode: 'UAE',
    currency: 'AED',
    currencyAr: 'د.إ',
    telephoneCode: '971',
    decimalDigits: 2,
    timezone: 'Asia/Dubai',
    gmt: '+4',
    currencyName: 'Dirham',
    currencyNameAr: 'درهم',
    numberStartsWith: [5],
    numberMinLength: 9,
    numberMaxLength: 10,
    vat: 5,
    location: {
      lat: 25.276987,
      lng: 55.296249,
    },
  },
  {
    countryName: 'Kuwait',
    countryNameAr: 'الكويت',
    shortCountryName: 'Kuwait',
    countryCode: 'KW',
    longCountryCode: 'KWT',
    currency: 'KWD',
    currencyAr: 'د.ك',
    telephoneCode: '965',
    decimalDigits: 3,
    timezone: 'Asia/Kuwait',
    gmt: '',
    currencyName: 'Dinar',
    numberStartsWith: [4, 5, 6, 9],
    numberMinLength: 8,
    numberMaxLength: 9,
    vat: 0,
    location: {
      lat: 29.37528,
      lng: 47.979189,
    },
  },
  {
    countryName: 'Bahrain',
    countryNameAr: 'البحرين',
    shortCountryName: 'Bahrain',
    countryCode: 'BH',
    longCountryCode: 'BHR',
    currency: 'BHD',
    currencyAr: 'د.ب',
    telephoneCode: '973',
    decimalDigits: 3,
    timezone: 'Asia/Bahrain',
    gmt: '',
    currencyName: 'Dinar',
    numberStartsWith: [3, 6],
    numberMinLength: 8,
    numberMaxLength: 9,
    vat: 5,
    location: {
      lat: 26.238583,
      lng: 50.586917,
    },
  },
  {
    countryName: 'Qatar',
    countryNameAr: 'قطر',
    shortCountryName: 'Qatar',
    countryCode: 'QA',
    longCountryCode: 'QAT',
    currency: 'QAR',
    currencyAr: 'ر.ق',
    telephoneCode: '974',
    decimalDigits: 2,
    timezone: 'Asia/Qatar',
    gmt: '',
    currencyName: 'Riyal',
    numberStartsWith: [3, 5, 6, 7],
    numberMinLength: 8,
    numberMaxLength: 9,
    vat: 0,
    location: {
      lat: 25.354826,
      lng: 51.521176,
    },
  },
  {
    countryName: 'Oman',
    countryNameAr: 'عمان',
    shortCountryName: 'OMN',
    countryCode: 'OM',
    longCountryCode: 'OMN',
    currency: 'OMR',
    currencyAr: 'ر.ع',
    telephoneCode: '968',
    decimalDigits: 3,
    timezone: 'Asia/Muscat',
    gmt: '',
    currencyName: 'Omani rial',
    numberStartsWith: [2, 7, 9],
    numberMinLength: 8,
    numberMaxLength: 9,
    vat: 5,
    location: {
      lat: 23.613109,
      lng: 58.592484,
    },
  },
]

export { countryData }
